import { render, staticRenderFns } from "./ClientData.vue?vue&type=template&id=c021ed68"
import script from "./ClientData.vue?vue&type=script&lang=js"
export * from "./ClientData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports